import { render, staticRenderFns } from "./history-list.vue?vue&type=template&id=bed49cda&scoped=true&"
import script from "./history-list.vue?vue&type=script&lang=js&"
export * from "./history-list.vue?vue&type=script&lang=js&"
import style0 from "./history-list.vue?vue&type=style&index=0&id=bed49cda&scoped=true&lang=css&"
import style1 from "./history-list.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed49cda",
  null
  
)

export default component.exports